import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectProjectControlItemComponent } from '../selectProjectControlItem/select-project-control-item.component';

@Component({
    standalone: false,
  selector: 'integration-apps-poam',
  templateUrl: './integration-apps-poam.component.html',
  styleUrls: ['./integration-apps-poam.component.css'],
  providers: [DialogService],
})
export class IntegrationAppsPoamComponent implements OnInit, OnDestroy {
  @Input() settings: any;
  @Input() settingsForm: FormGroup;

  currentStatusOptions = [
    { name: '0 - Not Started', value: 0 },
    { name: '1 - In-Progress', value: 1 },
    { name: '2 - Resolved', value: 2 },
    { name: '3 - Awaiting Review', value: 3 },
    { name: '4 - Reviewed - Not POAM', value: 4 }
  ];

  riskLevelOptions = ['High', 'Medium', 'Low'];

  controlsDialogRef: DynamicDialogRef | undefined;

  get control(): string {
    const project = this.settingsForm.get('projectName')?.value ?? '';
    const complianceArea = this.settingsForm.get('complianceArea')?.value ?? '';
    const complianceAreaControlId =
      this.settingsForm.get('complianceAreaControlId')?.value ?? '';

    return `${project} ${complianceAreaControlId} ${complianceArea}`;
  }

  constructor(
    public dialogRef: DynamicDialogRef,
    public dialogService: DialogService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.controlsDialogRef?.close();
  }

  initForm() {
    this.settingsForm.addControl(
      'projectName',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'complianceAreaName',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'complianceAreaControlId',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'projectId',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'name',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'weaknessDescription',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'howIdentified',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'responsibleParty',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'identificationDate',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'scheduledCompletionDate',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'actualCompletionDate',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'currentStatus',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'riskLevel',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'remediationPlansActionsMilestones',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'changesToRemediationPlansActionsMilestones',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'comments',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);
  }

  addControl() {
    this.controlsDialogRef = this.dialogService.open(
      SelectProjectControlItemComponent,
      {
        width: '70%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10010,
        maximizable: true,
        data: {},
        header: 'Select control',
      }
    );

    this.controlsDialogRef.onClose.subscribe((data: any) => {
      if (data) {
        const value = {
          complianceAreaControlId: data.controlItem.complianceAreaControlId,
          complianceAreaName: data.controlItem.complianceAreaName,
          projectId: data.projectId,
          projectName: data.projectName,
        };

        this.settingsForm.patchValue(value);
      }
    });
  }
}
